module.exports = __webpack_public_path__ + "img/comic6.jpg";